import { useEffect, useState, useMemo } from "react";
import { useGetService } from "./useGetService";
import { API, DashboardTabs } from "../constants";
import { getUserData } from "../shared/utils";

// Third party
import _ from "lodash";
import { IServiceRequest, ITmResponse } from "../types/global.types";
import { useArrivalDepartureData } from "./useArrivalDepartureData";
import { addDays } from "../utils/date.utils";
import moment from "moment";

export const usePastAssignedDetails = (startDate?: Date, endDate?: Date) => {
  const [rows, setRows] = useState<any>([]);
  const [isRowsLoading, setRowsLoading] = useState(false);

  const vendorId = getUserData()["cognito:username"];
  const yesterday = addDays(new Date(), -1);
  const defaultStartDate = startDate || addDays(yesterday, -7);
  const defaultEndDate = endDate || yesterday;

  const formattedStartDate = useMemo(
    () => moment(defaultStartDate).format("DD/MM/YYYY"),
    [defaultStartDate]
  );
  const formattedEndDate = useMemo(
    () => moment(defaultEndDate).format("DD/MM/YYYY"),
    [defaultEndDate]
  );

  const apiUrl = useMemo(
    () =>
      `${API.CARNIVAL_ADMIN.GET_SERVICE_REQUEST_BY_VENDOR_ID}?vendorId=${vendorId}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
    [vendorId, formattedStartDate, formattedEndDate]
  );

  // FETCH ALL DATA

  const {
    response: allResponse,
    isLoading: allResponseLoading,
    handleSearchApply,
    refreshingText,
  } = useArrivalDepartureData({
    startDate: defaultEndDate,
    endDate: defaultStartDate,
    selectedTab: DashboardTabs.ARRIVALS,
  });

  // FETCH ASSIGNMENT
  const {
    response,
    isLoading,
    refetch: refetchAssinged,
  } = useGetService(apiUrl);

  useEffect(() => {
    setRowsLoading(isLoading || allResponseLoading);

    if (!isLoading && !allResponseLoading) {
      const processedData = dataHandling(
        Array.isArray(allResponse) ? allResponse : allResponse?.data ?? [],
        Array.isArray(response?.data) ? response.data : []
      );
      setRows(processedData);
    }

    // Explicit clear when no assigned
    if (!isLoading && response?.data?.length === 0) {
      setRows([]);
    }
  }, [
    response,
    isLoading,
    allResponse,
    allResponseLoading,
    startDate,
    endDate,
  ]);
  const dataHandling = (
    resData: ITmResponse[],
    assignedRes: IServiceRequest[]
  ) => {
    // filter dates based on selected date range
    const filteredResData = assignedRes.filter((x) => {
      const arrivalDate = new Date(x.arrivalDate);
      return arrivalDate >= defaultStartDate && arrivalDate <= defaultEndDate;
    });

    const responseMap = new Map<string, any>();
    resData.forEach((res: { EmpId: string }) => {
      responseMap.set(res.EmpId, res);
    });

    console.log("filteredResData", filteredResData);

    return filteredResData.map((assigned) => {
      // if (assigned.isUnManifested === true) {
      //   return {
      //     ...assigned,
      //     isUnManifested: true,
      //     cancelled: false, // unmanifested isn't cancelled
      //   };
      // }

      const resMatch = responseMap.get(assigned.tmId);

      // cancelled if no match found
      const isCancelled = !resMatch;

      return {
        ...resMatch,
        ...assigned,
        cancelled: isCancelled,
      };
    });
  };

  const refetchData = () => {
    setRows([]);
    refetchAssinged(apiUrl);
    handleSearchApply();
  };

  return {
    rows,
    isRowsLoading,
    refetchData,
  };
};
